import { useEffect } from 'react'
import { useAppDispatch, useAppSelector } from '../store/hooks'
import { fetchDashboard } from '../store/dashboardSlice'
import { TodaysTreatments } from '../components/dashboard/TodaysTreatments'
import { PendingRefills } from '../components/dashboard/PendingRefills'
import { DrugAlerts } from '../components/dashboard/DrugAlerts'
import { LabResultsAwaitingReview } from '../components/dashboard/LabResultsAwaitingReview'

export function DashboardPage() {
  const dispatch = useAppDispatch()
  const { todaysTreatments, pendingRefills, drugAlerts, labResultsAwaitingReview, loading } =
    useAppSelector((s) => s.dashboard)

  useEffect(() => {
    dispatch(fetchDashboard())
  }, [dispatch])

  if (loading) {
    return (
      <div className="p-6 max-sm:p-3" data-testid="dashboard-page">
        <p className="text-[13px] text-text-muted">Loading dashboard...</p>
      </div>
    )
  }

  return (
    <div className="p-6 max-sm:p-3" data-testid="dashboard-page">
      <h1 className="text-[16px] max-sm:text-[20px] font-semibold text-text-primary mb-6">Dashboard</h1>

      <div className="grid grid-cols-1 gap-6">
        <div className="bg-surface rounded-[6px] p-4 max-sm:p-3" style={{ boxShadow: 'var(--shadow-elevation-1)' }}>
          <TodaysTreatments treatments={todaysTreatments} />
        </div>

        <div className="grid grid-cols-2 max-md:grid-cols-1 gap-6">
          <div className="bg-surface rounded-[6px] p-4 max-sm:p-3" style={{ boxShadow: 'var(--shadow-elevation-1)' }}>
            <PendingRefills refills={pendingRefills} />
          </div>

          <div className="bg-surface rounded-[6px] p-4 max-sm:p-3" style={{ boxShadow: 'var(--shadow-elevation-1)' }}>
            <DrugAlerts alerts={drugAlerts} />
          </div>
        </div>

        <div className="bg-surface rounded-[6px] p-4 max-sm:p-3" style={{ boxShadow: 'var(--shadow-elevation-1)' }}>
          <LabResultsAwaitingReview results={labResultsAwaitingReview} />
        </div>
      </div>
    </div>
  )
}
